import React, { useState } from 'react';

interface SearchBarProps {
    initialSearchTerm: string;
    onSearch: (searchTerm: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ initialSearchTerm, onSearch }) => {
    const [searchTerm, setSearchTerm] = useState(initialSearchTerm);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newSearchTerm = e.target.value;
        setSearchTerm(newSearchTerm);
        onSearch(newSearchTerm);
    };

    const handleClearSearch = () => {
        setSearchTerm('');
        onSearch('');
    };

    return (
        <form className="relative flex-grow sm:flex-grow-0" onSubmit={(e) => e.preventDefault()}>
            <input
                type="text"
                placeholder="Search by Name, Role and Status"
                className="w-full sm:w-80 pl-10 pr-9 py-2 border border-border rounded-[8px] text-[16px] focus:outline-none"
                value={searchTerm}
                onChange={handleSearchChange}
            />
            <svg className="w-5 h-5 text-text-secondary absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-testid="search-icon">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            {searchTerm && (
                <button
                    className="absolute right-3 top-3 text-text-secondary hover:text-text-primary"
                    onClick={handleClearSearch}
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            )}
        </form>
    );
};

export default SearchBar;
